export interface EndorsedSkill {
  name: string
  endorsements: number
  peers?: string
  colleagues?: string
}

export const endorsedSkills: EndorsedSkill[] = [
  {
    name: 'Product Management',
    endorsements: 75,
    peers: 'Endorsed by Nathan Bobbin and 6 others who are highly skilled at this',
    colleagues: 'Endorsed by 3 colleagues at ibi | Information Builders',
  },
  {
    name: 'Data Integration',
    endorsements: 66,
    peers: 'Endorsed by Steven Totman and 22 others who are highly skilled at this',
    colleagues: 'Endorsed by 14 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Enterprise Software',
    endorsements: 45,
    peers: 'Endorsed by Michael Curry and 11 others who are highly skilled at this',
    colleagues: 'Endorsed by 7 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Data Quality',
    endorsements: 37,
    peers: 'Endorsed by Jon Asprey and 4 others who are highly skilled at this',
    colleagues: 'Endorsed by 8 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Cloud Computing',
    endorsements: 32,
    peers: 'Endorsed by Rich Dill and 1 other who is highly skilled at this',
    colleagues: 'Endorsed by 6 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Big Data',
    endorsements: 29,
    peers: 'Endorsed by Steven Totman and 4 others who are highly skilled at this',
    colleagues: 'Endorsed by 7 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Business Intelligence',
    endorsements: 27,
    peers: 'Endorsed by Rick Sherman and 7 others who are highly skilled at this',
    colleagues: 'Endorsed by 4 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Go-to-market Strategy',
    endorsements: 25,
    peers: 'Endorsed by Derek Britton and 1 other who is highly skilled at this',
    colleagues: 'Endorsed by 2 colleagues at ibi | Information Builders',
  },
  {
    name: 'Strategy',
    endorsements: 23,
    peers: 'Endorsed by Andrew J. Friedrich, CISSP, CCSK. and 1 other who is highly skilled at this',
    colleagues: 'Endorsed by 6 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Sales Enablement',
    endorsements: 19,
    peers: 'Endorsed by Derek Britton who is highly skilled at this',
    colleagues: 'Endorsed by 4 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Data Warehousing',
    endorsements: 18,
    peers: 'Endorsed by Steven Totman and 2 others who are highly skilled at this',
    colleagues: 'Endorsed by 7 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'SaaS',
    endorsements: 17,
    peers: 'Endorsed by Kim Hutchinson Schlimme and 2 others who are highly skilled at this',
    colleagues: 'Endorsed by 3 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Master Data Management',
    endorsements: 16,
    peers: 'Endorsed by Martin ABC Hansen and 1 other who is highly skilled at this',
    colleagues: 'Endorsed by 2 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Pre-sales',
    endorsements: 10,
    peers: 'Endorsed by Javier Legazpi and 1 other who is highly skilled at this',
    colleagues: 'Endorsed by 3 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Product Marketing',
    endorsements: 9,
    peers: 'Endorsed by Stephanie Best and 1 other who is highly skilled at this',
    colleagues: 'Endorsed by 3 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Agile Methodologies',
    endorsements: 7,
    colleagues: 'Endorsed by 4 colleagues at IBM',
  },
  {
    name: 'Solution Selling',
    endorsements: 7,
    colleagues: 'Endorsed by 3 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Integration',
    endorsements: 6,
    peers: 'Endorsed by Larry Pieniazek and 2 others who are highly skilled at this',
    colleagues: 'Endorsed by 4 colleagues at IBM',
  },
  {
    name: 'SOA',
    endorsements: 5,
    colleagues: 'Endorsed by 3 colleagues at IBM',
  },
  {
    name: 'Analytics',
    endorsements: 5,
    colleagues: 'Endorsed by 3 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Hadoop',
    endorsements: 4,
    colleagues: 'Endorsed by 3 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Software Development',
    endorsements: 3,
    peers: 'Endorsed by Rich Dill who is highly skilled at this',
    colleagues: 'Endorsed by 2 colleagues at IBM',
  },
  {
    name: 'Demand Generation',
    endorsements: 3,
  },
  {
    name: 'Cross-functional Team Leadership',
    endorsements: 3,
  },
  {
    name: 'Leadership',
    endorsements: 2,
    colleagues: 'Endorsed by 2 colleagues at ibi | Information Builders',
  },
  {
    name: 'Software Industry',
    endorsements: 2,
    colleagues: 'Endorsed by 2 colleagues at Syncsort (now Precisely)',
  },
  {
    name: 'Customer Data Integration',
    endorsements: 2,
  },
  { name: 'Channel Partners', endorsements: 1 },
  { name: 'Distributed Systems', endorsements: 1 },
  { name: 'ETL', endorsements: 1 },
  { name: 'Product Launch', endorsements: 1 },
  { name: 'Strategic Planning', endorsements: 1 },
]

export const additionalSkills: string[] = [
  'Cross-functional Collaborations',
  'Customer Advisory Boards',
  'Consultative Selling',
  'Intelligence Analysis',
  'Integrating Acquisitions',
  'Strategic M&A',
  'Packaging Design',
  'Strategic Transformation',
  'Syncsort',
  'International Acquisitions',
  'Product Innovation',
  'Product Development',
  'Customer Satisfaction',
  'Product Analysis',
  'Competitive Pricing',
  'Due Diligence',
  'Team Facilitation',
  'Strategic Business Initiatives',
  'Launching New Brands',
  'Computer Science',
  'CIM qualified',
  'Product Road Mapping',
  'Certified Scrum Product Owner',
  'Product Strategy',
  'Thought Leadership',
  'Global Product Management',
  'GTM',
  'Management',
]
